export default "__VITE_ASSET__BHwPlFny__"